var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.44444,
    y: -4.44444,
    width: 48.8889,
    height: 48.8889
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.22px)",
      clipPath: "url(#bgblur_0_5445_229164_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4.44444,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9164 19.1833L21.9272 16.1941M13.333 27.7775L15.8622 27.4964C16.1712 27.4621 16.3257 27.4449 16.4701 27.3982C16.5982 27.3567 16.7202 27.2981 16.8326 27.224C16.9593 27.1404 17.0692 27.0305 17.2891 26.8106L27.1584 16.9414C27.9838 16.1159 27.9838 14.7776 27.1584 13.9521C26.3329 13.1266 24.9946 13.1266 24.1691 13.9521L14.2998 23.8214C14.08 24.0412 13.9701 24.1511 13.8865 24.2779C13.8124 24.3903 13.7538 24.5122 13.7123 24.6403C13.6655 24.7847 13.6484 24.9393 13.614 25.2483L13.333 27.7775Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5445_229164_clip_path",
    transform: "translate(4.44444 4.44444)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesDraw);
export default __webpack_public_path__ + "static/media/stories-draw.1ad97c7e855226d7159c49601d2e0836.svg";
export { ForwardRef as ReactComponent };